<template>
    <div class="gv-category-field">
        <label class="form-label" for="gv-category">Catégorie <small>*</small></label>
        <div>
            <select id="gv-category" class="form-select gv-category-select" v-model="currentCategoryComponent">
                <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                <option :value="-1">+ Nouvelle catégorie…</option>
            </select>
            <div v-if="currentCategoryComponent === -1" class="mt-2">
                <label class="visually-hidden" for="gv-new-category">Nom de la nouvelle catégorie</label>
                <input
                    id="gv-new-category"
                    type="text"
                    maxlength="255"
                    class="form-control"
                    placeholder="Nom de la nouvelle catégorie"
                    :value="modelValue ?? value"
                    @input="emitName($event.target.value)" />
            </div>
            <ShowErrors class="d-block" :errors="errors" errorKey="custom_category_name" />
            <ShowErrors class="d-block" :errors="errors" errorKey="categories" />
        </div>
    </div>
</template>

<script>
import ShowErrors from "../../errors/ShowErrors";

export default {
    name: "GiftVouchersCategoryComponent",
    props: {
        categories: {
            type: Array,
            required: true,
        },
        currentCategory: {
            type: Number,
            default: null,
        },
        errors: {
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
        modelValue: {
            type: String,
            default: undefined,
        },
    },
    emits: ["category-changed", "input", "update:modelValue"],
    computed: {
        currentCategoryComponent: {
            get() {
                return this.currentCategory;
            },
            set(newValue) {
                this.$emit("category-changed", newValue);
            },
        },
    },
    methods: {
        emitName(name) {
            this.$emit("input", name);
            this.$emit("update:modelValue", name);
        },
    },
    components: {
        ShowErrors,
    },
};
</script>

<style scoped>
.gv-category-field {
    display: grid;
    grid-template-columns: 13rem minmax(0, 1fr);
    gap: 0.25rem 1rem;
    align-items: start;
    margin-bottom: 0.85rem;
}

.gv-category-field > .form-label {
    margin: 0;
    padding-top: 0.45rem;
}

.gv-category-select {
    max-width: 20rem;
}

@media (max-width: 767px) {
    .gv-category-field {
        grid-template-columns: minmax(0, 1fr);
    }

    .gv-category-field > .form-label {
        padding-top: 0;
    }
}
</style>
